import { t } from "@lingui/core/macro"
import {
    FollowNotificationFrequency,
    type IFollowing,
} from "../../../types/follow"
import { parseFollowNotificationFrequency } from "../../../utils/followUtils"
import { addPageAction } from "../../../utils/newrelic"
import { FollowStar } from "../../common/molecules/FollowStar/FollowStar"
import { toast } from "../common/Toast/ToastManager"
import { useMessagingContext } from "../MessagingContext"
import type { FollowResponse } from "../../../store/followSlice"
import type { EventRouter } from "../types"

const handleLoggedOut = (username: string) => {
    window.location.href = `/auth/login/?next=/${username}/`
}

const createAfterFollow = (followingEvent: EventRouter<IFollowing>) => {
    return (username: string, response: FollowResponse) => {
        toast.fire({
            message: t`Following ${username}`,
            position: "top",
            preset: "dark",
            showIcon: false,
        })
        addPageAction("DmFollow", {
            followAction: "follow",
        })

        const payload: IFollowing = {
            roomName: username,
            following: true,
            followNotificationFrequency: parseFollowNotificationFrequency(
                response.notification_frequency,
            ),
            onlineCount: response.online_count,
            totalCount: response.total_count,
        }
        followingEvent.fire(payload)
    }
}

const createAfterUnfollow = (followingEvent: EventRouter<IFollowing>) => {
    return (username: string, response: FollowResponse) => {
        toast.fire({
            message: t`No longer following ${username}`,
            position: "top",
            preset: "dark",
            showIcon: false,
        })
        addPageAction("DmFollow", {
            followAction: "unfollow",
        })

        const payload: IFollowing = {
            roomName: username,
            following: false,
            followNotificationFrequency: FollowNotificationFrequency.NONE,
            onlineCount: response.online_count,
            totalCount: response.total_count,
        }
        followingEvent.fire(payload)
    }
}

const onFail = () => {
    toast.fire({
        message: t`Something went wrong. Reload the page and try again.`,
        position: "top",
        preset: "dark",
        showIcon: false,
    })
}

export const MessageFollowStar = ({ username }: { username: string }) => {
    const { followingEvent } = useMessagingContext()

    const afterFollow = createAfterFollow(followingEvent)
    const afterUnfollow = createAfterUnfollow(followingEvent)

    return (
        <FollowStar
            username={username}
            afterFollow={afterFollow}
            afterUnfollow={afterUnfollow}
            handleLoggedOut={handleLoggedOut}
            onFail={onFail}
        />
    )
}
